﻿export default class ReservationTimer {
    constructor() {
        this._runCounter = this._runCounter.bind(this);
        this._getTime = this._getTime.bind(this);
        this._startCountDown = this._startCountDown.bind(this);
        this.init();
        let _this = this;
        document.addEventListener("cartUpdateEvent", () => {
            _this._getTime();
        });

    }

    init() {
        this.cleanupWillOccurAt = cleanupWillOccurAtViewBag;
        this._startCountDown();
    }

    _getTime() {

        let _this = this;

        $.ajax({
            url: "/Cart/GetReservationTimerData",
            dataType: "json",
            type: "GET",
            success: function (response) {
                $("#SeatReservationTimeEndedModal a").href = "/seating/arenaSeatFirst/" + response.eventId + "?IsSeason=" + response.isSeason;
                _this.cleanupWillOccurAt = parseInt(response.cleanupWillOccurAt);
                _this._startCountDown();
            },
            error: function () {
                $("#cleanupWillOccurAt").html("");
                _this.cleanupWillOccurAt = null;
                _this._runCounter();

            }
        });
    }

    _startCountDown() {
        if (this.cleanupWillOccurAt && this.cleanupWillOccurAt != null) {
            clearInterval(this.x);
            this._runCounter(); // to run immediately
            this.x = setInterval(this._runCounter.bind(this), 1000);

        } else
        {
            $('.reservationCountDown-div').hide();
            clearInterval(this.x);
        }
    }

    _runCounter() {
        let _this = this;
        let endTime = new Date(_this.cleanupWillOccurAt * 1000);

        let _second = 1000;
        let _minute = _second * 60;
        let _hour = _minute * 60;
        var now = new Date();
        var duration = endTime - now;

        var minutes = Math.floor((duration % _hour) / _minute);
        var seconds = Math.floor((duration % _minute) / _second);
        

        if (duration < 0) {
            clearInterval(this.x);
            $.ajax({
                url: "/Cart/SeatReservationTimerHasEnded",
                dataType: "json",
                type: "GET",
                success: function (response) {


                    if (response.success) {
                        const seatReservationTimeEndedModal = document.getElementById("SeatReservationTimeEndedModal");
                        if (seatReservationTimeEndedModal) {
                            $('.reservationCountDown-div').attr('hidden', 'true');
                            $("#SeatReservationTimeEndedModal").modal('show');
                        }
                    }
                    else {
                        if (response.newTime) {
                            _this.cleanupWillOccurAt = response.newTime;
                            return _this._startCountDown();

                        }
                        else {
                            window.location.href = "/";

                        }
                    }
                },
                error: function () {
                    window.location.href = "/";
                }
            });

        }
        else {

            minutes = minutes < 10 ? "0" + minutes : minutes;
            seconds = seconds < 10 ? "0" + seconds : seconds;
            $('.seatReservationCountDown').each(function (i, obj) {
                document.getElementsByClassName("seatReservationCountDown")[i].innerHTML = minutes + ":" + seconds;
                $('.reservationCountDown-div').fadeIn('fast');
            });
        }
    }
}
    
    
